export default {
	userFirstName(state){
		if(state.user){
			return state.user.UsuarioPersonaNombre || ''
		} else {
			return ''
		}
	},
	orAc(state){
		if(	state.user && 
			state.organizadorActivo && 
			Number(state.organizadorActivo) > 0 && 
			(state.user.IsOrganizador === 'true' || state.user.IsOrganizador === true) && 
			state.user.Organizaciones.length > 0
		){
			let organizador = state.user.Organizaciones.find((o) => Number(o.OrganizadorId) === Number(state.organizadorActivo))
			let permisos = []
			organizador.Permisos.forEach((p) => { permisos.push(p.OrganizadorPermisoCodigo) })
			organizador.Permisos = permisos

			return organizador
		} else {
			return null
		}
	}
}